import base from "@/store/utils/api-route/base";

// const base = 'https://stoplight.io/mocks/smartlink/smartlink-api-stoplight-owner/131809582/' //mockup

const jenisMemberApi = {
    listMemberLite: `${base.masterData}/promoProxy/member/master/meta/list-member-lite`,
}

export default jenisMemberApi;